module.exports = __webpack_public_path__ + "media/images/brand/favicon-01-de1fae937eba08697d1075dad3f138cc.png";